import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PersonPhoneService } from '../person-phone.service';
import { PersonPhone } from '../person-phone';
import { PersonService } from '@app/_components/person';

@Component({
    selector: 'app-person-phone',
    templateUrl: './person-phone.component.html',
    styleUrls: ['./person-phone.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PersonPhoneComponent implements OnInit {
    personId: any;
    persons: any;
    phoneTypes: any;

	constructor(
		private personService: PersonService,
		private primengConfig: PrimeNGConfig,
		private personPhoneService: PersonPhoneService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.personPhone = data.personPhone,
			this.personId = data.personId,
			this.statuses = personPhoneService.statuses;
			this.phoneTypes =  this.personService.phoneTypes;
	}

	@Input() personPhone: PersonPhone;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	personPhoneId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'personPhoneId': [],
		'type': [],
		'countryCode': [],
		'phoneNum': [],
		'personId': [],
	};

	ngOnInit() {
		this.fetchPersons();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole personPhone object
		if (this.personPhone) {
			this.personPhoneId = this.personPhone.personPhoneId;
			this.fixDates();
			this.form1.patchValue(this.personPhone);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.personPhoneId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.form1.value.personId = this.personId;
			this.personPhoneService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personPhone = res.data.phone;
						this.doAdd.emit(this.personPhone);
					},
					(err: any) => {
						console.log('personPhone-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('personPhone: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.personPhoneService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personPhone = res.data.phone;
						this.doUpdate.emit(this.personPhone);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.personPhoneService.delete(this.personPhone.personPhoneId)
				.subscribe(
					(res: any) => {
						console.log('personPhone-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.personPhone);
					},
					(err: any) => {
						console.log('personPhone-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			personPhoneId: [this.personPhoneId],
			type: [],
			countryCode: [],
			phoneNum: [],
			personId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.personPhone.personPhoneDate = moment(this.personPhone.personPhoneDate).toDate();
	}
	
	fetchPersons() {
		if (!this.persons || this.persons === undefined || this.persons.length < 1) {
			try {
				this.personService.findAll()
					.subscribe(
						res => {
							console.log('findAllPersons: ' + JSON.stringify(res));
							this.persons = res.data.persons;
							return this.persons;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.persons);
		}
	}
}
